import { isBizNull } from "../utils";
import { createSelector } from "reselect";
import { orderTypes, planType } from "../utils/lynkco-constants";

export const pdpCheckoutProgressSelector = state => state.pdpCheckoutProgress;
export const pdpDiffAddrSelector = state => state.pdpDiffAddr;
export const pdpOrderPreviewSelector = state => state.pdpOrderPreview;
export const pdpDeliverySelector = state => state.pdpDelivery;
export const pdpShippingSelector = state => state.pdpShipping;
export const pdpPersonalInfoSelector = state => state.pdpPersonalInfo;
export const pdpBillingSelector = state => state.pdpBilling;
export const pdpSummarySelector = state => state.pdpSummary;
export const pdpLoanLeadsDataSelector = state => {
  return state.pdpLoanLeadsData;
};
export const pdpIsLoanSelector = createSelector(pdpSummarySelector, summary => summary?.apiBody?.subType === orderTypes.buyACarLoan);
export const pdpTouchPointSelector = state => state.pdpTouchPoint;
export const pdpBundleSelector = state => state.pdpBundle;
export const pdpLccSelector = state => state.pdpLcc;
export const pdpLccIdSelector = state => !isBizNull(state.pdpLcc) && !isBizNull(state.pdpLcc.id) && state.pdpLcc.id.toString();
export const pdpPlanTypeSelector = state => state.pdpPlanType;
export const pdpLoanOrderStatusSelector = state => state.pdpLoanOrderStatus;
export const pdpMarketSelector = state => state.pdpMarket;

export const pdpSavePaymentSelector = createSelector(pdpPlanTypeSelector, pdpOrderPreviewSelector, (pdpPlanType, pdpOrderPreview) => {
  const { orderExtraData = {} } = pdpOrderPreview || {};
  const { isWithServicePackage = "0", isCarWheelService = "0" } = orderExtraData || {};
  return pdpPlanType === planType.MtM || (pdpPlanType === planType.BaC && (isWithServicePackage == "1" || isCarWheelService == "1"));
});
export const pdpStockSelector = state => state.pdpStock;
export const pdpOutOfStockSelector = createSelector(pdpStockSelector, stock => {
  if (!stock) {
    return false;
  } else {
    return stock.length === 0 || !stock[0] || stock[0].availableQty === 0;
  }
});
export const pdpRiskCheckSelector = state => state.pdpRiskCheck;
